import { useRef } from "react";
import ModalPop from "../../home/ModalPop";

const RightQuick = () => {
  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };
  return (
    <>
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <div className="fixed right-2 bottom-16 lg:bottom-auto lg:right-10 lg:top-1/3 lg:-translate-y-20 w-fit h-fit z-10">
        <div className="relative w-fit h-fit max-w-16 lg:max-w-20">
          <button
            type="button"
            onClick={() => window.open("https://open.kakao.com/o/sh9LWMfi")}
            className=" relative w-fit h-fit max-w-16 lg:max-w-20 mb-3.5 hover:-translate-y-3 transition-transform duration-200 hover:shadow-lg rounded-full"
          >
            <img
              src="/images/iconKakao.webp"
              alt="카카오톡 상담 바로가기"
              className="!relative w-full h-full object-contain"
            />
          </button>
          <button
            type="button"
            onClick={() => window.open("https://blog.naver.com/kainos_hanam")}
            className=" relative w-fit h-fit max-w-16 lg:max-w-20 mb-3.5 hover:-translate-y-3 transition-transform duration-200 hover:shadow-lg rounded-full"
          >
            <img
              src="/images/iconBlog.webp"
              alt="네이버 블로그 바로가기"
              className="!relative w-full h-full object-contain"
            />
          </button>
          <button
            type="button"
            onClick={openfunc}
            className=" relative w-fit h-fit max-w-16 lg:max-w-20 mb-3.5 hover:-translate-y-3 transition-transform duration-200 hover:shadow-lg rounded-full"
          >
            <img
              src="/images/iconContact.webp"
              alt="견적문의 바로가기"
              className="!relative w-full h-full object-contain"
            />
          </button>
          <button
            type="button"
            onClick={openfunc}
            className=" relative w-fit h-fit max-w-16 lg:max-w-20 hover:-translate-y-3 transition-transform duration-200 hover:shadow-lg rounded-full"
          >
            <img
              src="/images/iconCall.webp"
              alt="전화 상담 바로가기"
              className="!relative w-full h-full object-contain"
            />
          </button>
        </div>
      </div>
    </>
  );
};

export default RightQuick;
